import React from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import TodoDashboard from '../../../components/TodoDashboard/TodoDashboard';
import FollowUpDashboard from '../../../components/FollowUpDashboard/FollowUpDashboard';
import {
    getFollowUpAbnormalities,
    getSearchFollowUpAbnormalities,
    getIsFollowUpFetching,
    getTodoAbnormalities,
    getSearchTodoAbnormalities,
    getIsTodoFetching,
    storeSearchFollowUpAbnormalities,
    loadFollowUpAbnormalities,
    storeSearchTodoAbnormalities,
    loadTodoAbnormalities,
    INITIAL_TODO_ABN_SEARCH_FORM,
    INITIAL_FOLLOW_UP_ABN_SEARCH_FORM,
} from '../duck';

class DashboardAbnormalities extends React.Component {
    render() {
        const {
            todo,
            searchTodo,
            isFetchingTodo = false,
            loadTodoAbnormalities,
            storeSearchTodoAbnormalities,
            followUp,
            searchFollowUp,
            isFetchingFollowUp = false,
            loadFollowUpAbnormalities,
            storeSearchFollowUpAbnormalities,
        } = this.props;

        return (
            <Row>
                <Col style={{ margin: 20 }}>
                    <TodoDashboard
                        title="TODO"
                        data={todo}
                        search={searchTodo}
                        emptySearch={INITIAL_TODO_ABN_SEARCH_FORM}
                        isFetching={isFetchingTodo}
                        actions={{
                            loadData: loadTodoAbnormalities,
                            storeSearch: storeSearchTodoAbnormalities,
                        }}
                    />
                    <FollowUpDashboard
                        title="FOLLOW-UP"
                        data={followUp}
                        search={searchFollowUp}
                        emptySearch={INITIAL_FOLLOW_UP_ABN_SEARCH_FORM}
                        isFetching={isFetchingFollowUp}
                        actions={{
                            loadData: loadFollowUpAbnormalities,
                            storeSearch: storeSearchFollowUpAbnormalities,
                        }}
                    />
                </Col>
            </Row>
        );
    }
}

DashboardAbnormalities.defaultProps = {
    todo: [],
    searchTodo: INITIAL_TODO_ABN_SEARCH_FORM,
    isFetchingTodo: false,
    followUp: [],
    searchFollowUp: INITIAL_FOLLOW_UP_ABN_SEARCH_FORM,
    isFetchingFollowUp: false,
};

export default connect(
    state => ({
        todo: getTodoAbnormalities(state),
        searchTodo: getSearchTodoAbnormalities(state),
        isFetchingTodo: getIsTodoFetching(state),
        followUp: getFollowUpAbnormalities(state),
        searchFollowUp: getSearchFollowUpAbnormalities(state),
        isFetchingFollowUp: getIsFollowUpFetching(state),
    }),
    {
        loadTodoAbnormalities,
        storeSearchTodoAbnormalities,
        loadFollowUpAbnormalities,
        storeSearchFollowUpAbnormalities,
    }
)(DashboardAbnormalities);
